import React from 'react';
import { Typography, Paper, useTheme, useMediaQuery } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { PuntoTemporal } from '../../../types/consolidatedReport.types';

interface TrendLineChartProps {
  datos: PuntoTemporal[];
}

const TrendLineChart: React.FC<TrendLineChartProps> = ({ datos }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const data = datos.map(punto => ({
    periodo: punto.period_label,
    promedio: Math.round(punto.average * 10) / 10,
    cantidad: punto.quantity
  }));

  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: isMobile ? 2 : 3,
        width: '100%',
        overflow: 'hidden'
      }}
    >
      <Typography variant={isMobile ? 'body1' : 'h6'} gutterBottom sx={{ fontWeight: 600 }}>
        Tendencia Temporal
      </Typography>
      <ResponsiveContainer width="100%" height={isMobile ? 250 : 300}>
        <LineChart 
          data={data}
          margin={{ 
            left: isMobile ? -10 : 0,
            right: isMobile ? 10 : 20,
            top: 5,
            bottom: 5
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="periodo" tick={{ fontSize: isMobile ? 9 : 12 }} />
          <YAxis domain={[0, 100]} tick={{ fontSize: isMobile ? 10 : 12 }} />
          <Tooltip formatter={(value: number) => `${value.toFixed(1)}%`} />
          <Legend wrapperStyle={{ fontSize: isMobile ? '11px' : '14px' }} />
          <Line 
            type="monotone" 
            dataKey="promedio" 
            stroke="#667eea" 
            strokeWidth={isMobile ? 2 : 3}
            dot={{ r: isMobile ? 3 : 5 }}
            activeDot={{ r: isMobile ? 5 : 8 }}
            name="Cumplimiento"
          />
        </LineChart>
      </ResponsiveContainer>
    </Paper>
  );
};

export default TrendLineChart;
